import { getJSONCriteria } from "modules/businessCriteria";
import { AllRules } from "modules/businessCriteria/types";
import { ListingForm } from "components/shared/TableListing/types";
import { initialTableData } from "./constants";
import { TierEntity, TierTableContext } from "./types";
import { TierCreateVariables, TierUpdateVariables, TierJSONCriteria } from "./api";

export function mergeDefaultTierWithApiByIndex(tier: TierEntity, index: number): TierEntity {
  const { name, color, description, ...other } = tier;

  return {
    name: name ?? initialTableData[index].name,
    color: color ?? initialTableData[index].color,
    description: description ?? initialTableData[index].description,
    ...other,
  };
}

function getJSONCriteriaFromFormData(formData: ListingForm<TierEntity, TierTableContext>) {
  return formData.bodyFields.reduce<TierJSONCriteria[]>((acc, tier, index) => {
    const conditions = Object.entries(tier.criteria ?? {}).map(([fact, values]) => ({
      fact: fact as AllRules,
      ...values,
    }));

    acc.push({ ...mergeDefaultTierWithApiByIndex(tier, index), ...getJSONCriteria(conditions) });

    return acc;
  }, []);
}

export function collectCreateAPIPayloadFromTiers(
  accountId: string,
  formData: ListingForm<TierEntity, TierTableContext>
): TierCreateVariables["input"] {
  return {
    accountId,
    validDateEnd: null,
    validDateStart: null,
    structure: "INTERNAL_CREDIT_TIERS",
    nameInternal: "INTERNAL_CREDIT_TIERS",
    financeProgramModificationSettings: { markup: false },
    prescreenCriteriaInput: {
      name: "INTERNAL_CREDIT_TIERS",
      notes: null,
      accountId,
      guidelines: null,
      lenderProfileIdsToLink: [],
      financeProgramIdsToLink: [],
      jsonCriteria: getJSONCriteriaFromFormData(formData),
    },
  };
}

export function collectUpdateAPIPayloadFromTiers(
  accountId: string,
  prescreenCriteriaId: string,
  formData: ListingForm<TierEntity, TierTableContext>
): TierUpdateVariables["input"] {
  return {
    accountId,
    prescreenCriteriaId,
    jsonCriteria: getJSONCriteriaFromFormData(formData),
  };
}
